<app-page-title title="Dashboard"></app-page-title>

<div class="carroussel" *ngIf="banners?.length > 0">
  <div class="navigation-wrapper">
    <div class="keen-slider keen-slider--vertical" #sliderRef>
      <div *ngFor="let banner of banners" [class]="'keen-slider__slide number-slide' + banner.id">
        <img [src]="banner.file" />
      </div>
    </div>
    <svg
      [ngClass]="'arrow arrow--left ' + (currentSlide === 0 ? 'arrow--disabled' : '')"
      (click)="slider.prev()"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
    </svg>
    <svg
      *ngIf="slider"
      [ngClass]="
        'arrow arrow--right ' + (slider.track.details.slides.length - 1 === currentSlide ? 'arrow--disabled' : '')
      "
      (click)="slider.next()"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
    </svg>
  </div>
  <div class="dots">
    <button
      (click)="slider.moveToIdx(i)"
      *ngFor="let slide of dotHelper; let i = index"
      [class]="'dot ' + (i === currentSlide ? 'active' : '')"
    ></button>
  </div>
</div>

<div class="card-container" *ngIf="!!membersCount && !!groupsCount && !!lastFrequencies">
  <div id="title">
    <br />
    <h3><b>Dados de membros</b></h3>
  </div>
  <div class="cards">
    <div class="card">
      <div class="details">
        <img class="icon-white" src="../../assets/icons/people-white.svg" width="100" />
      </div>
      <div class="details">
        <p>Membros</p>
        <h1>{{ membersCount }}</h1>
      </div>
    </div>

    <div class="card">
      <div class="details">
        <img src="../../assets/icons/groups.svg" width="100" />
      </div>
      <div class="details">
        <p>Células</p>
        <h1>{{ groupsCount }}</h1>
      </div>
    </div>

    <div class="card">
      <div class="details">
        <img src="../../assets/icons/groups.svg" width="100" />
      </div>
      <div class="details">
        <p>Frequências Pendentes</p>
        <h1>{{ lastFrequencies }}</h1>
      </div>
    </div>
  </div>
</div>

<div *ngIf="birthdays?.length > 0" class="card-container">
  <div id="title">
    <br />
    <h3><b>Aniversariantes</b></h3>
  </div>
  <div class="birthdays">
    <div *ngFor="let birthday of birthdays" class="birthday">
      <img
        class="avatar"
        *ngIf="birthday?.avatar"
        [src]="getAvatar(birthday?.avatar)"
        [matTooltip]="birthday?.name"
        matTooltipClass="tooltip"
      />

      <img
        class="avatar"
        *ngIf="!birthday?.avatar"
        [matTooltip]="birthday?.name"
        matTooltipClass="tooltip"
        src="../../../assets/icons/default-user-icon-profile.png"
      />

      <div class="birthday-body">
        <div class="name">
          {{ birthday?.name }}
        </div>
        <div class="group">
          {{ birthday?.group?.name || 'sem célula' }}
        </div>
      </div>
      <div class="date">
        <h1 class="day">{{ birthday?.date.split('/')[0] }}/{{ birthday?.date.split('/')[1] }}</h1>
      </div>
    </div>
  </div>
</div>

<!-- <carousel>
  <div class="carousel-cell">
    <h1>111</h1>
  </div>
  <div class="carousel-cell">
    <h1>111</h1>
  </div>
  <div class="carousel-cell">
    <h1>111</h1>
  </div>
</carousel>
<app-loader> </app-loader>

-->
